export function isPhotoImage(value = "") {
  return /^\/uploads\//.test(value) || /^https?:\/\//.test(value);
}
